module.exports = __webpack_public_path__ + "static/media/auv_video_still.bc85b42c.png";